/* eslint-disable react-hooks/exhaustive-deps */
import $ from "jquery";
import { io } from "socket.io-client";
import { useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

import {
  DOMAIN,
  FOCUS,
  MUC,
  SERVICEURL,
  SOCKET_URL,
  TOKEN,
  WEBSOCKETKEEPALIVEURL,
  SOCKET_CON,
  MEDIA_SET,
  WIDGET_HIDE,
  MEDIA_PLAYER,
  MEDIA_PLAYER_SEEK_UPD,
} from "./constants";

var room = null;
var connection = null;
window.isJoined = false;
window.pageload = true;
var roomId = null;
let socket = null;

var isHide = false;
export default function Home() {
  const { param } = useParams();
  const conference_room = param.toLowerCase();
  const conferenceWithPrefix =
    conference_room &&
    (conference_room?.startsWith("meetn_") ||
      conference_room?.startsWith("rlink_") ||
      conference_room?.startsWith("meetndev_") ||
      conference_room?.startsWith("rlinkdev_"));
  const roomname = conferenceWithPrefix ? conference_room?.substring(conference_room.indexOf('_') + 1) : conference_room;

    console.log('roomname',roomname);

  const [isConnect, setIsConnect] = useState(false);
  const [localTracks, setLocalTracks] = useState([]);
  const [isFilename, setIsFilename] = useState(false);
  const videoSrcRef = useRef("");
  const [, setRoomUserID] = useState("");
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [widgetId, setWidgetId] = useState("");
  const [seekInterval, setSeekInterval] = useState(null);
  const [itemDetail, setItemDetail] = useState({});

  const filename = window.location.hash.split("=")[1];
  const token = TOKEN;
  const options = {
    hosts: {
      domain: DOMAIN,
      muc: MUC,
      focus: FOCUS,
    },
    serviceUrl: SERVICEURL,
    websocketKeepAliveUrl: WEBSOCKETKEEPALIVEURL,
    deploymentInfo: {
      environment: "meetn",
      region: "us",
      userRegion: "us",
    },
    disableAudioLevels: true,
  };
  const remoteTracks = {};

  useEffect(() => {
    videoSrcRef.current.oncanplay = getLocalMediaStream;
    videoSrcRef.current.onended = onPlayEnd;
    joinSocket().then((response) => {
      console.log("response", response);
      createNewConnection(response);
    });
  }, []);
  useEffect(() => {
    if (roomname) {
      const leftVideo = document.getElementById("leftVideo");
      leftVideo.muted = false;
      leftVideo.autoplay = false;
      leftVideo.loop = false;
      leftVideo.load();
    }
  }, [roomname]);
  useEffect(() => {
    if (!isConnect && isFilename) {
    }
    if (isConnect && !isFilename) {
      unload2();
    }
  }, [isConnect, isFilename, isDisconnecting]);
  useEffect(() => {
    if (isConnect) {
      const conferenceLocalTracks = room?.getLocalTracks();
      if (conferenceLocalTracks.length > 0) {
        let audioTrackNew = null;
        let videoTrackNew = null;
        let audioTrackOld = null;
        let videoTrackOld = null;
        let localTrackType = null;
        let conferenceLocalTrackType = null;
        for (let i = 0; i < localTracks.length; i++) {
          localTrackType = localTracks[i].getType();
          if (localTracks[i].getType() === "audio") {
            audioTrackNew = localTracks[i];
          }
          if (localTracks[i].getType() === "video") {
            videoTrackNew = localTracks[i];
          }
        }
        for (let i = 0; i < conferenceLocalTracks.length; i++) {
          conferenceLocalTrackType = conferenceLocalTracks[i].getType();
          if (conferenceLocalTracks[i].getType() === "audio") {
            audioTrackOld = conferenceLocalTracks[i];
          }
          if (conferenceLocalTracks[i].getType() === "video") {
            videoTrackOld = conferenceLocalTracks[i];
          }
        }

        console.log("audioTrackOld", audioTrackOld);
        console.log("audioTrackNew", audioTrackNew);
        if (audioTrackOld && audioTrackNew) {
          console.log("Add new audio track", audioTrackOld?.isMuted());
          if (audioTrackOld?.isMuted()) {
            audioTrackNew
              ?.mute()
              .then(() => {
                room.addTrack(audioTrackNew);
              })
              .catch((error) => {
                // Add track without muting
                room.addTrack(audioTrackNew);
              });
          } else {
            room.addTrack(audioTrackNew);
          }
        } else if (!audioTrackOld && audioTrackNew) {
          console.log("Add new audio track 2", audioTrackNew?.isMuted());
          room.addTrack(audioTrackNew);
        } else if (audioTrackOld && !audioTrackNew) {
          console.log("Remove old audio track");
          room.removeTrack(audioTrackOld);
        }
        if (videoTrackOld && videoTrackNew) {
          room.addTrack(videoTrackNew);
        } else if (!videoTrackOld && videoTrackNew) {
          room.addTrack(videoTrackNew);
        } else if (videoTrackOld && !videoTrackNew) {
          room.removeTrack(videoTrackOld);
        }
      } else {
        for (let i = 0; i < localTracks.length; i++) {
          try {
            room.addTrack(localTracks[i]);
          } catch (_err) {}
        }
      }
    }
  }, [isConnect, localTracks]);
  const joinSocket = () => {
    return new Promise((resolve) => {
      const socketURL = SOCKET_URL;
      socket = io.connect(socketURL, {
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 99999,
      });
      socket.on("connect", () => {
        console.log("SOCKET_CON", socket.connected);
        if (socket.connected) {
          socket.emit(
            SOCKET_CON,
            {
              room: roomname,
              token: token,
            },
            (resp) => {
              console.log("SOCKET_CON 2", SOCKET_CON, resp);
              mediaSetReceived(resp);
              socket = socket;
              return resolve(resp);
            }
          );
        }
      });
      socket.on(MEDIA_SET, (data) => {
        mediaSetReceived(data);
      });
      socket.on('show', (data) => {
        console.log('show', data);
        isHide = false;
      });
      socket.on('hide', (data) => {
        console.log('hide', data);
        isHide = true;
      });
    });
  };

  useEffect(() => {
    // Always clear the existing interval if any

    if (itemDetail?.file_duration && itemDetail?.file_duration > 0) {
      if (seekInterval !== null) {
        clearInterval(seekInterval);
        setSeekInterval(null);
      }
      if (widgetId !== "") {
        const seekIntervalValue = setInterval(() => {
          const video = document.getElementById("leftVideo");
          const seek_value = video?.currentTime;
          if (seek_value > 0) {
            updateMediaPlayerSeek({
              id: widgetId,
              seek_value: seek_value,
              room_id: itemDetail?.room_id,
              folder_id: itemDetail?.folder_id,
              main_id: itemDetail?.main_id,
            });
          }
        }, 1000);
        setSeekInterval(seekIntervalValue);
      }
    } else {
      if (seekInterval !== null) {
        clearInterval(seekInterval);
        setSeekInterval(null);
      }
    }

    // Clean up when component unmounts or widgetId changes
    return () => {
      if (seekInterval !== null) {
        clearInterval(seekInterval);
        setSeekInterval(null);
      }
    };
  }, [widgetId]);

  // function mediaSetReceived(data) {
  //   console.log('mediaSetReceived', data)
  //   let videoFilename = data.url ? true : false;
  //   let playStatus = data.play;
  //   let muteStatus = data.mute;
  //   let forwardStatus = data.forward;
  //   let backwardStatus = data.backward;
  //   let volumeValue = data.volume;
  //   let media_type = data.media_type;
  //   setIsFilename(videoFilename);
  //   changeSource(
  //     {
  //       roomname,
  //       url: data.url,
  //       playStatus,
  //       muteStatus,
  //       forwardStatus,
  //       backwardStatus,
  //       volumeValue,
  //       media_type
  //     }
  //   );
  // }

  function mediaSetReceived(data) {
    console.log("mediaSetReceived", isHide,data?.url);

    if(!isHide || (isHide && !data?.url)){
    const {
      url,
      play: playStatus,
      mute: muteStatus,
      forward: forwardStatus,
      backward: backwardStatus,
      volume: volumeValue,
      media_type,
      seek: IsSeeking,
      seekTo,
    } = data;

      setIsFilename(url ? true : false);
      setItemDetail(data);

      changeSource({
        roomname,
        url,
        playStatus,
        muteStatus,
        forwardStatus,
        backwardStatus,
        volumeValue,
        media_type,
        IsSeeking,
        seekTo,
        id: data?.id ?? "",
      });
    }
  }

  const onPlayEnd = async () => {
    // First ensure all tracks are muted
    const conferenceLocalTracks = room?.getLocalTracks?.() || [];
    for (const track of conferenceLocalTracks) {
      if (typeof track._setMuted === "function") {
        track._setMuted(true);
      }
    }

    // Then send the WIDGET_HIDE event
    socket.emit(WIDGET_HIDE, {
      room: roomname,
      extensionid: 52199,
    });
  };
  const createNewConnection = ({ prosody_token }) => {
    window.JitsiMeetJS.init(options);
    window.JitsiMeetJS.setLogLevel(window.JitsiMeetJS.logLevels.ERROR);
    connection = new window.JitsiMeetJS.JitsiConnection(
      DOMAIN,
      prosody_token,
      options
    );
    connection.addEventListener(
      window.JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED,
      onConnectionSuccess
    );
    connection.addEventListener(
      window.JitsiMeetJS.events.connection.CONNECTION_FAILED,
      onConnectionFailed
    );
    connection.addEventListener(
      window.JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED,
      disconnect
    );
    connection.connect();
  };
  async function getLocalMediaStream() {
    const leftVideo = videoSrcRef.current;
    let stream;
    const fps = 0;
    if (leftVideo.captureStream) {
      stream = leftVideo.captureStream(fps);
    } else if (leftVideo.mozCaptureStream) {
      stream = leftVideo.mozCaptureStream(fps);
    } else {
      stream = null;
    }
    console.log(stream);

    const _tracks = stream?.getTracks();
    const checkAudioTrack = _tracks?.some((track) => track.kind === "audio");
    const checkVideoTrack = _tracks?.some((track) => track.kind === "video");

    const audioTrack = {
      mediaType: "audio",
      stream: stream,
      sourceType: "canvas",
    };
    const videoTrack = {
      mediaType: "video",
      stream: stream,
      sourceType: "canvas",
      videoType: "camera",
    };

    const tracks = [];
    if (checkAudioTrack) {
      tracks.push(audioTrack);
    }
    if (checkVideoTrack) {
      tracks.push(videoTrack);
    }
    const newTracks =
      await window.JitsiMeetJS.createLocalTracksFromMediaStreams(tracks);
    onLocalTracks(newTracks);
    // .then(onLocalTracks)
    // .catch((error) => {
    //   throw error;
    // });
  }
  function onLocalTracks(tracks) {
    console.log("tracks", tracks);
    setLocalTracks(tracks);
  }
  function onConferenceJoined() {
    window.room = room;
    setRoomUserID(room.myUserId());
    roomId = room.myUserId();
    console.log("roomId=>", roomId);
    window.isJoined = true;
    setIsConnect(true);
    let int = null;
    const interval = setInterval(function () {
      if (room) {
        console.log(
          "room.getParticipantCount => ",
          room?.getParticipantCount()
        );
        if (
          room?.getParticipantCount() === 1 ||
          (room?.getParticipantCount() === 2 &&
            window.room
              .getParticipants()[0]
              .getConnectionJid()
              .split("@")[0] === "recorder")
        ) {
          if (int === null) {
            int = setInterval(function () {
              console.log("Closing Mediashare Since only one paricipant left");

              onConfLeft();
              clearInterval(int);
              clearInterval(interval);
            }, 30 * 1000);
          } else {
            // console.log("Interval is null");
          }
        } else {
          if (int) {
            clearInterval(int);
            int = null;
            // console.log("Setting Interval to null");
          }
        }
      } else {
        if (int) {
          clearInterval(int);
          int = null;
          // console.log("Setting Interval to null");
        }
      }
    }, 3 * 1000);
    // joinSocket();
  }
  async function onUserLeft(id) {
    if (!remoteTracks[id]) {
      return;
    }
    const tracks = remoteTracks[id];
    for (let i = 0; i < tracks?.length; i++) {
      tracks[i].detach($(`#${id}${tracks[i].getType()}`));
    }
  }

  async function onConfLeft() {
    console.log("confeence left called ", roomId, window?.closeBrowser);

    if (window?.closeBrowser) {
      console.log("confeence left closing browser", roomId);
      window.isJoined = false;
      socket.emit(WIDGET_HIDE, {
        room: roomname,
        extensionid: 52199,
      });

      await new Promise((resolve) => setTimeout(resolve, 2000));
      window.closeBrowser();
    } else {
      if (socket) {
        socket.disconnect();
      }
      unload();
      await new Promise((resolve) => setTimeout(resolve, 2000));
      room = null;
    }
  }
  function onConnectionSuccess() {
    console.log("conference_room", conference_room, roomname);
    room = connection.initJitsiConference(conference_room, options);
    room.on(window.JitsiMeetJS.events.conference.TRACK_REMOVED, (track) => {});
    room.on(
      window.JitsiMeetJS.events.conference.CONFERENCE_JOINED,
      onConferenceJoined
    );
    room.on(window.JitsiMeetJS.events.conference.USER_JOINED, (id) => {
      remoteTracks[id] = [];
    });
    room.on(window.JitsiMeetJS.events.conference.USER_LEFT, onUserLeft);
    room.on(window.JitsiMeetJS.events.conference.CONFERENCE_LEFT, onConfLeft);
    room.on(
      window.JitsiMeetJS.events.conference.TRACK_MUTE_CHANGED,
      (track) => {}
    );
    room.on(
      window.JitsiMeetJS.events.conference.DISPLAY_NAME_CHANGED,
      (userID, displayName) => {}
    );
    room.join();
    room.setDisplayName("Media-Sharing");
  }
  function onConnectionFailed() {
    console.error("Connection Failed!");
  }
  function disconnect() {
    console.log("disconnect");
    connection.removeEventListener(
      window.JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED,
      onConnectionSuccess
    );
    connection.removeEventListener(
      window.JitsiMeetJS.events.connection.CONNECTION_FAILED,
      onConnectionFailed
    );
    connection.removeEventListener(
      window.JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED,
      disconnect
    );
  }
  window.globalUnload = () => {
    for (let i = 0; i < localTracks.length; i++) {
      localTracks[i].dispose();
    }
    room.leave();
    connection.disconnect();
  };
// function unload2() {
  //   const conferenceLocalTracks = room?.getLocalTracks();
  //   console.log("conferenceLocalTracks", conferenceLocalTracks);
  //   setWidgetId("");
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       const promiseArr = [];

  //       for (let i = 0; i < conferenceLocalTracks.length; i++) {
  //         const track = conferenceLocalTracks[i];
  //         // Mute the track first
  //         if (track.setMuted) {
  //           track.setMuted(true);
  //         }
  //         // Remove the track from the room
  //         promiseArr[i] = room.removeTrack(track);
  //         // Dispose of the track after removal
  //         promiseArr[i].then(() => {
  //           if (track.dispose) {
  //             track.dispose();
  //           }
  //         });
  //       }

  //       if (conferenceLocalTracks.length > 0) {
  //         Promise.all(promiseArr).then(() => {
  //           console.log(" promiseArr resolve");
  //           resolve();
  //         }).catch((error) => {
  //           console.error("Error removing tracks:", error);
  //           resolve(); // Still resolve even if some tracks fail to remove
  //         });
  //       } else {
  //         resolve();
  //       }
  //     }, 1000);
  //   });
  // }

  async function unload2() {
    try {
      const conferenceLocalTracks = room?.getLocalTracks?.() || [];
      console.log("conferenceLocalTracks", conferenceLocalTracks);

      setWidgetId("");

      // Mute all tracks first
      for (const track of conferenceLocalTracks) {
        if (typeof track._setMuted === "function") {
          try {
            await track._setMuted(true);
            console.log("Track muted successfully");
          } catch (err) {
            console.warn("Failed to mute track:", err);
          }
        }
      }

      // Remove all tracks from the room
      const removalPromises = conferenceLocalTracks.map((track) =>
        room
          ?.removeTrack?.(track)
          ?.then(() => {
            if (typeof track.dispose === "function") {
              track.dispose();
              console.log("Track disposed successfully");
            }
          })
          .catch((err) => {
            console.error("Error removing or disposing track:", err);
          })
      );

      await Promise.all(removalPromises);
      console.log("All tracks removed and disposed");
    } catch (error) {
      console.error("Error in unload2:", error);
    }
  }


  function unload() {
    setIsConnect(false);
    setIsDisconnecting(true);
    setTimeout(() => {
      for (let i = 0; i < localTracks.length; i++) {
        localTracks[i].dispose();
      }
      room.leave();
      connection.disconnect().then(() => {
        setIsDisconnecting(false);
      });
    }, 1000);
  }
  $(window).bind("beforeunload", unload);
  $(window).bind("unload", unload);

  async function changeSource({
    roomname,
    url,
    playStatus,
    muteStatus,
    forwardStatus,
    backwardStatus,
    volumeValue,
    IsSeeking,
    seekTo,
    id,
  }) {
    let currenttimeUTC = new Date().toISOString();
    let timeStampUTC = Date.parse(currenttimeUTC);
    console.log("volumeValue", volumeValue, url, muteStatus);
    var video = document.getElementById("leftVideo");
    console.log("video.currentTime", video?.currentTime);
    let currentURL = videoSrcRef?.current?.src ? videoSrcRef?.current?.src : "";
    const forwardSeconds = 10;
    const backwardSeconds = 10;
    if (url) {
      // var vid = await new URL(url).pathname.replace("/media/", "");
      // if (vid) {
      //   console.log(`captek vid`, vid);
      //   url = `https://wss-east-msb.meetn.com:2096/resources/${vid}`;
      //   console.log(`captek url`, url);
      // }

      const currentPlayingUrl = getBaseUrl(currentURL);
      const newUrl = getBaseUrl(url);
      console.log(`currentPlayingUrl`, currentPlayingUrl !== newUrl);
      if (currentPlayingUrl !== newUrl) {
        if (seekInterval !== null) {
          clearInterval(seekInterval);
          setSeekInterval(null);
        }
        video.src = url;
        if (playStatus) {
          video.play();
          setWidgetId(id);
        } else if (!playStatus) {
          video.pause();
          setWidgetId("");
        }
      } else {
        if (playStatus) {
          video.play();
          setWidgetId(id);
        } else if (!playStatus) {
          video.pause();
          setWidgetId("");
        }
      }

      console.log(`action`, IsSeeking, seekTo);
      if (IsSeeking) {
        video.currentTime = seekTo;
        let payload = {
          room: roomname,
          seek: false,
          seekTo: null,
          action: "seek",
          msb: true,
        };
        updateMediaPlayer(payload);
      }
      if (forwardStatus) {
        video.currentTime += forwardSeconds;
        (async () => {
          let payload = {
            room: roomname,
            forward: false,
            action: "forward",
            actionTime: timeStampUTC,
            msb: true,
          };
          updateMediaPlayer(payload);
        })();
      }
      if (backwardStatus) {
        video.currentTime -= backwardSeconds;
        (async () => {
          let payload = {
            room: roomname,
            backward: false,
            action: "backward",
            actionTime: timeStampUTC,
            msb: true,
          };
          updateMediaPlayer(payload);
        })();
      }
      video.volume = volumeValue ?? 1;

      if (muteStatus) {
        muteLocalAudioTrack();
      } else {
        unmuteLocalAudioTrack();
      }
      video.muted = muteStatus ?? false;
    } else {
      video.src = "";
    }
  }

  const updateMediaPlayer = (payload) => {
    if (socket) socket.emit(MEDIA_PLAYER, payload);
  };

  const updateMediaPlayerSeek = (payload) => {
    if (socket) socket.emit(MEDIA_PLAYER_SEEK_UPD, payload);
  };
  function muteLocalAudioTrack() {
    const localTracks = room?.getLocalTracks();
    const localAudioTrack = localTracks?.find(
      (track) => track.getType() === "audio"
    );
    console.log("muteLocalAudioTrack", localAudioTrack?.isMuted());
    if (localAudioTrack && !localAudioTrack?.isMuted()) {
      localAudioTrack.mute();
    }
  }

  function unmuteLocalAudioTrack() {
    const localTracks = room?.getLocalTracks();
    const localAudioTrack = localTracks?.find(
      (track) => track.getType() === "audio"
    );
    console.log("unmuteLocalAudioTrack", localAudioTrack?.isMuted());

    if (localAudioTrack && localAudioTrack?.isMuted()) {
      localAudioTrack.unmute();
    }
  }

  function getBaseUrl(url) {
    if (!url || typeof url !== "string") {
      return null; // Handle invalid URL or non-string input
    }

    try {
      const parsed = new URL(url);
      return `${parsed.origin}${parsed.pathname}`;
    } catch (error) {
      console.log("Invalid URL:", url);
      return null;
    }
  }

  return (
    <>
      <div>
        <video
          style={{ width: 700, height: 200 }}
          id="leftVideo"
          controls
          ref={videoSrcRef}
          crossOrigin="*"
        >
          <source src={filename} type="video/mp4" />
          <p>MSB</p>
        </video>
      </div>
    </>
  );
}
